var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.339 21.103h19.3a.36.36 0 0 0 .36-.353V7.323a.357.357 0 0 0 0-.038v-.022a.355.355 0 0 0-.026-.086v-.014a.357.357 0 0 0-.043-.067L18.333 3.02a.36.36 0 0 0-.268-.123H5.935a.36.36 0 0 0-.268.123L2.07 7.096a.357.357 0 0 0-.043.067v.014A.355.355 0 0 0 2 7.263v.022a.355.355 0 0 0 0 .038V20.75a.36.36 0 0 0 .338.353zm3.76-17.489H17.88l1.029 1.163H5.069ZM4.647 5.257h14.685l1.508 1.707H3.137Zm-1.95 2.426H21.28v12.708h-3.117v-5.537l1.41 1.41a.24.24 0 0 0 .338-.338l-1.817-1.817a.24.24 0 0 0-.34 0l-1.818 1.817a.24.24 0 0 0 .338.338l1.41-1.41v5.53h-4.436v-5.53l1.41 1.41a.24.24 0 0 0 .338-.338l-1.818-1.817a.24.24 0 0 0-.34 0l-1.817 1.817a.24.24 0 0 0 .338.338l1.41-1.41v5.53H2.698Z",
    style: {
      strokeWidth: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.019 11.76H8.98a.24.24 0 0 0 0 .48h6.038a.24.24 0 0 0 0-.48z",
    style: {
      strokeWidth: 0.5
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.4aabf3b4.svg";
export { ForwardRef as ReactComponent };